// extracted by mini-css-extract-plugin
export var actionButton = "_jc-t";
export var buttonContainer = "_jc-0";
export var buttonContainer2 = "_jc-1";
export var buttonSection = "_jc-2";
export var details = "_jc-3";
export var dropdownItem = "_jc-5";
export var dropdownItemsContainer = "_jc-4";
export var fileInput = "_jc-r";
export var headerButton = "_jc-6";
export var icon = "_jc-7";
export var input = "_jc-8";
export var macroListItem = "_jc-9";
export var mainContent = "_jc-a";
export var microText = "_jc-b";
export var modal = "_jc-w";
export var optionsButton = "_jc-c";
export var paperclip = "_jc-s";
export var pillContent = "_jc-d";
export var preview = "_jc-e";
export var preview2 = "_jc-f";
export var quillEditor = "_jc-q";
export var selectedMacro = "_jc-g";
export var sidebar = "_jc-h";
export var sidebarHeader = "_jc-j";
export var sidebarList = "_jc-i";
export var sidebarListItem = "_jc-k";
export var sidebarSearch = "_jc-l";
export var snoozeDurationWrapper = "_jc-v";
export var statusPillContainer = "_jc-m";
export var tagsContainer = "_jc-n";
export var unselectedMacro = "_jc-o";
export var variable = "_jc-u";
export var wrapper = "_jc-p";